import React, { useState, useEffect, useContext } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { AuthContext } from "./context/AuthContext";
import AppRoutes from "./router/routes";
import Preloader from "./components/Preloader";

function App() {
  const { loadingPreloader } = useContext(AuthContext);

  if (loadingPreloader) {
    return <Preloader />;
  }

  return (
    <>
      <ToastContainer position="top-right" autoClose={5000} />
      <AppRoutes />
    </>
  );
}

export default App;
